<template>
    <div class="section">

        <!-- Modal Structure -->
        <!-- <div id="modal1" class="modal"> -->
        <div class="modal-content">
            <h4>{{ title }}</h4>
            <p>{{ message }}</p>
        </div>
        <div class="modal-footer">
            <a href="#!" @click.prevent="handleConfirm(false)"
                class="modal-close waves-effect waves-green btn-flat">Cancel</a>
            <a href="#!" @click.prevent="handleConfirm(true)"
                class="modal-close waves-effect waves-green btn-flat">Confirm</a>
        </div>
        <!-- </div> -->

    </div>
</template>

<script>
import { onMounted, onUpdated } from "vue";
import nativeUi from "@/ui/native-ui";

export default {
    name: "modalComponent",
    props: ["title", "message"],
    emits: ["confirm"],
    setup(props, context) {

        // alert
        onMounted(() => {
            // modal
            const elems = document.querySelectorAll(".modal");
            nativeUi.Modal.init(elems, {});
        });

        // alert
        onUpdated(() => {
            // modal
            const elems = document.querySelectorAll(".modal");
            nativeUi.Modal.init(elems, {});
        });

        // Confirmation
        const handleConfirm = (val) => {
            context.emit("confirm", val);
        }


        return {
            handleConfirm,
        };
    },
};
</script>

<style>
.modal {
    background: var(--ui-popover, #ffffff);
    border: 1px solid var(--ui-border, #e2e8f0);
    border-radius: var(--ui-radius, 0.5rem);
    box-shadow: var(--ui-shadow-overlay, 0 24px 56px rgb(15 23 42 / 0.24));
    color: var(--ui-popover-foreground, #0f172a);
    display: none;
    left: 50%;
    max-height: calc(100dvh - 2rem);
    max-width: 36rem;
    overflow-y: auto;
    position: fixed;
    top: 50%;
    transform: translate(-50%, -50%);
    width: calc(100% - 2rem);
    z-index: 250;
}

.modal.is-open {
    display: block;
}

.modal .modal-content {
    padding: 1.5rem;
}

.modal .modal-content h4 {
    color: inherit;
    font-family: var(--ui-font-display, inherit);
    font-size: 1.125rem;
    font-weight: 700;
    margin: 0;
}

.modal .modal-content p {
    color: var(--ui-muted-foreground, #64748b);
    font-size: 0.875rem;
    line-height: 1.55;
    margin: 0.65rem 0 0;
}

.modal .modal-footer {
    align-items: center;
    background: transparent;
    border-top: 1px solid var(--ui-border, #e2e8f0);
    display: flex;
    gap: 0.5rem;
    justify-content: flex-end;
    min-height: 0;
    padding: 1rem 1.5rem;
}

.modal .modal-footer .btn-flat {
    align-items: center;
    background: var(--ui-background, #ffffff);
    border: 1px solid var(--ui-border, #e2e8f0);
    border-radius: calc(var(--ui-radius, 0.5rem) - 2px);
    color: var(--ui-foreground, #0f172a);
    display: inline-flex;
    font-size: 0.8125rem;
    font-weight: 600;
    justify-content: center;
    min-height: 2.5rem;
    padding: 0 0.9rem;
    text-decoration: none;
}

.modal .modal-footer .btn-flat:last-child {
    background: var(--ui-primary, #0f172a);
    border-color: var(--ui-primary, #0f172a);
    color: var(--ui-primary-foreground, #ffffff);
}

@media (max-width: 480px) {
    .modal .modal-footer {
        align-items: stretch;
        flex-direction: column-reverse;
    }

    .modal .modal-footer .btn-flat {
        width: 100%;
    }
}
</style>
